var _path, _g, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeaderboardRank2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 50,
    viewBox: "0 0 44 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.3103 12.4995V37.4995L21.6551 50L0 37.4995V12.4995L21.6551 0L43.3103 12.4995Z",
    fill: "url(#paint0_linear_3472_7760)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.2975 14.2395V35.7606L21.6565 46.5201L3.01562 35.7606V14.2395L21.6565 3.479L40.2975 14.2395Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0963 32V29.36C17.4563 28.512 18.6163 27.72 19.5763 26.984C20.5363 26.248 21.3123 25.552 21.9043 24.896C22.5123 24.24 22.9603 23.616 23.2483 23.024C23.5363 22.432 23.6803 21.856 23.6803 21.296C23.6803 20.688 23.4963 20.184 23.1283 19.784C22.7763 19.368 22.2483 19.16 21.5443 19.16C20.7923 19.16 20.2083 19.44 19.7923 20C19.3763 20.544 19.1523 21.344 19.1203 22.4L15.5923 21.32C15.6243 20.136 15.9043 19.144 16.4323 18.344C16.9763 17.544 17.7123 16.944 18.6403 16.544C19.5683 16.128 20.6243 15.92 21.8083 15.92C22.8483 15.92 23.7443 16.072 24.4963 16.376C25.2643 16.664 25.8883 17.056 26.3683 17.552C26.8483 18.032 27.2003 18.576 27.4243 19.184C27.6643 19.776 27.7843 20.384 27.7843 21.008C27.7843 22.032 27.5203 22.992 26.9922 23.888C26.4643 24.768 25.6963 25.624 24.6883 26.456C23.6963 27.272 22.4883 28.096 21.0643 28.928V28.952C21.3363 28.936 21.6563 28.92 22.0243 28.904C22.3923 28.888 22.7763 28.88 23.1763 28.88C23.5763 28.864 23.9363 28.856 24.2563 28.856H27.9763V32H16.0963Z",
    fill: "#231F20"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3472_7760",
    x1: 0,
    y1: 25,
    x2: 43.3103,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98ADC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A2BBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#B8D6E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#B3B4D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#AF9AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#AC8ABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#AC85BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A784BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#9A83B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#8482AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#6580A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#3E7E98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#367E96"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboardRank2);
export default __webpack_public_path__ + "static/media/Leaderboard_rank_2.75cef52740ef975625aef44565eea923.svg";
export { ForwardRef as ReactComponent };